export default "__VITE_ASSET__DYktme4N__"